import React from "react";
import "./Banner.css";

function Banner({ imgSrc, videoSrc }) {
  return (
    <>
      <section className="Banner">
        <div className="container">
          <div className="img-div">
            {videoSrc ? (
              <video
                className="ban-img"
                src={process.env.PUBLIC_URL + videoSrc}
                autoPlay
                loop
                muted
              />
            ) : (
              <img
                className="ban-img"
                src={process.env.PUBLIC_URL + imgSrc}
                alt="Banner"
              />
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Banner;
